<div class="td-cnt-ext">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}" id="teiasoftDialog">
        <div class="td-cnt-title">
            <div class="title">
                <div style="flex-grow: 5;">
                    <i class="fal fa-edit dialog-icon"></i>
                    <span class="te-title">{{'enquiryBook.editInPlaceCosts' | translate}} - {{this.enquiryNo}}</span>
                    <span *ngIf="title" class="settings-btn" (click)="showSettings()"><i
                            class="fa-wrench fal"></i></span>
                </div>
                <div class="total-margin" style="flex-grow: 0.1;">
                    <div class="total-row">
                        <span>{{'enquiryBook.overallPrice' | translate}} : </span>
                        <span>{{getTotalPrice()}}</span>
                    </div>
                    <div class="total-row">
                        <span [ngClass]="priceClass()">{{'enquiryBook.overallMargin' | translate}} : </span>
                        <span [ngClass]="priceClass()">{{getTotalMargin()}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- TOOLBAR CNT -->
        <div class="cnt-toolbar">
            <div class="cnt-toolbar-left">
                <teiasoft-toolbar [buttonsList]="groupsButtonsList" (onBtnClick)="onBtnToolbarClick($event)"
                    [noMargin]="true" style="width:auto; display:block;"></teiasoft-toolbar>
            </div>
            <div class="cnt-toolbar-right">
                <teiasoft-toolbar [buttonsList]="buttonsList" (onBtnClick)="onBtnToolbarClick($event)"
                    [noMargin]="true" style="width:auto; display:block;"></teiasoft-toolbar>
            </div>
        </div>
        <div class="td-cnt-body">
            <div #tableContainer class="table-container" (click)="clearItemColumnQuickSelection()" (scroll)="onTableContainerScroll()">
                <!-- Header Row -->
                <div class="header-row" #headerRow>
                    <!-- Checkbox column for selecting a row -->
                    <div class="header-cell">
                        <div class="checkbox-cell">
                            <input type="checkbox" (change)="onSelectAll($event)" (click)="$event.stopPropagation()"
                                [checked]="getSelectedItems(filteredItems).length > 0 && getSelectedItems(filteredItems).length == filteredItems.length"
                                [indeterminate]="getSelectedItems(filteredItems).length > 0  && getSelectedItems(filteredItems).length < filteredItems.length" />
                        </div>
                    </div>
                    <!--  -->
                    <div *ngFor="let col of columns.items; trackBy: trackByColumn;let c = index " class="header-cell"
                        resizableColumn [class.sticky-column]="isFrozenItemColumn(col)"
                        [class.column-hide-selected]="isItemColumnQuickHideSelected(col)"
                        [shouldRecalculate]="recalculateColumnsWidth" [style.left.px]="getStickyLeftPosition(col)"
                        (onColumnWidthUpdate)="onColumnWidthUpdate($event)" [columnName]="col"
                        [resizingFlag]="resizingFlag" [resizeSelector]="resizeSelector"
                        [gridConfiguration]="gridConfiguration" (onResizeEnd)="onColumnResizeEnd()"
                        (click)="onItemColumnHeaderClick(col, $event)">
                        <button *ngIf="hasHeaderToggleBefore(col)" type="button"
                            class="hidden-columns-restore hidden-columns-restore-left"
                            [matTooltip]="getHeaderToggleBeforeTooltip(col)"
                            matTooltipPosition="below" (click)="onHeaderToggleBefore(col, $event)">
                            <i [class]="getHeaderToggleBeforeIcon(col)"></i>
                        </button>
                        <div class="header-item-cell-content">
                            <span> {{getColumnHeaderLabel(col!)}}</span>
                        </div>
                        <button *ngIf="hasHeaderToggleAfter(col)" type="button"
                            class="hidden-columns-restore"
                            [matTooltip]="getHeaderToggleAfterTooltip(col)"
                            matTooltipPosition="below" (click)="onHeaderToggleAfter(col, $event)">
                            <i [class]="getHeaderToggleAfterIcon(col)"></i>
                        </button>
                    </div>
                    <div *ngFor="let col of columns.extraCosts;let c = index; trackBy: trackByColumn"
                        class="header-cell header-extra-costs" resizableColumn
                        [shouldRecalculate]="recalculateColumnsWidth"
                        (onColumnWidthUpdate)="onColumnWidthUpdate($event)" [columnName]="col"
                        [resizingFlag]="resizingFlag" [resizeSelector]="resizeSelector"
                        [gridConfiguration]="gridConfiguration" [style.width.px]="getColumnWidth(col)"
                        (onResizeEnd)="onColumnResizeEnd()">
                        <span> {{col}}</span>
                    </div>
                    <div *ngFor="let col of columns.costs;let c = index; trackBy: trackByColumn" class="header-cost"
                        resizableColumn (onColumnWidthUpdate)="onColumnWidthUpdate($event)" [columnName]="col"
                        [shouldRecalculate]="recalculateColumnsWidth" [resizingFlag]="resizingFlag"
                        [resizeSelector]="resizeSelector" [gridConfiguration]="gridConfiguration"
                        [style.width.px]="getColumnWidth(col)"
                        (onResizeEnd)="onColumnResizeEnd()">
                        <span>{{getCostHeaderLabel(col)}}</span>
                        <span *ngIf="getSelectedItems().length > 0 && canIncreaseColumn(col)"
                            class="increase-btn" (click)="onIncreaseColumnClick(col)"><i
                                class="fal fa-plus-minus"></i></span>
                    </div>
                </div>

                <!-- Filters Row -->
                <div class="filter-row data-row" [style.display]="gridFilterable?  '' : 'none'">
                    <!-- Checkbox Column (empty) -->
                    <div class="data-cell checkbox-cell"></div>

                    <!-- Columns Filters -->
                    <div *ngFor="let col of (columns.items.concat(columns.extraCosts, columns.costs)); let c = index;trackBy: trackByCol"
                        class="data-cell" [class.sticky-column]="isFrozenItemColumn(col)"
                        [style.left.px]="getStickyLeftPosition(col)" [style.width.px]="getColumnWidth(col)">

                        <teiasoft-input *ngIf="getFilterType(col) == 'text' || getFilterType(col) == 'number'"
                            [size]="'s'" (onInput)="onFilterInputChange($event, col!)"
                            [labelText]="'grid.contains' | translate" style="width: 100%;" [type]="getFilterType(col)"
                            [isMultiOperator]="getFilterType(col) == 'number'"
                            [disabled]="getSelectedItems().length > 0" [value]="getFilterValue(col)"
                            [clearValue]="clearFilters">
                        </teiasoft-input>

                        <!-- (onSelected)="onSelectedBoolean($event, col.column!)" -->
                        <teiasoft-select *ngIf="getFilterType(col) == 'boolean'" [size]="'s'"
                            [optionsList]="booleanColumnsOptions" [filterVersion]="true"
                            [labelText]="'grid.equals' | translate" style="width: 100%"
                            (onSelected)="onSelectedFilterOptions([$event.value], col!)"
                            [defaultValue]="getSelectDefaultValue(col)" [disabled]="getSelectedItems().length > 0"
                            [clearValue]="clearFilters">
                        </teiasoft-select>

                        <!-- (onSelectedFilterOptions)="onSelectedFilterOptions($event, col.column!, col.filterType!)" -->
                        <teiasoft-select-options *ngIf="getFilterType(col) == 'multi-select'"
                            [inputValues]="[filtersValues]" [colName]="col" [oDataFilterMaps]="filterMaps"
                            [inputValues]="filtersValues" [disabled]="getSelectedItems().length > 0"
                            (onSelectedFilterOptions)="onSelectedFilterOptions($event,col)"
                            [clearValue]="clearFilters"></teiasoft-select-options>
                    </div>
                </div>


                <!-- Data Rows -->
                <div *ngFor="let item of filteredItems; let i = index; trackBy: trackByItem" class="data-row"
                    [ngClass]="{'row-selected' : item['isSelected']}" (click)="onRowClick(item,i)">
                    <!-- Checkbox column to enable row editing -->
                    <div #checkboxContainer class="data-cell checkbox-cell" (click)="onRowSelected(item, i, $event)">
                        <input type="checkbox" [(ngModel)]="item['isSelected']" />
                    </div>
                    <div *ngFor="let col of columns.items;let c = index; trackBy: trackByColumn" class="data-cell"
                        [ngClass]="{'mismatch' : hasMismatch(item,col)}"
                        [class.sticky-column]="isFrozenItemColumn(col)"
                        [style.left.px]="getStickyLeftPosition(col)" [style.width.px]="getColumnWidth(col)">
                        <ng-container *ngIf="item['isSelected'] && isEditableItemColumn(col, item)">
                            <teiasoft-confirmable-input [type]="getInputType(col)" [value]="getInputValue(item,col)"
                                (confirmChange)="onConfirmChange($event, item, col)"
                                (onValueChanged)="onValueChanged($event, item, col)"
                                [options]="uomOptionsMap[col+'_'+item.unitSystem]" style="width: 100%;"
                                [allowNegative]="doesColumnAllowNegative(col)">
                            </teiasoft-confirmable-input>
                        </ng-container>
                        <ng-container *ngIf="!item['isSelected'] || !isEditableItemColumn(col,item)">
                            <span>{{ getInputValue(item,col) }}</span>
                        </ng-container>
                    </div>
                    <div *ngFor="let col of columns.extraCosts; trackBy: trackByColumn"
                        [ngClass]="getConfirmableInputClass(col,item)" class="data-cell"
                        [style.width.px]="getColumnWidth(col)">
                        <!-- If the row is in edit mode, use confirmable-input for editable fields -->
                        <ng-container *ngIf="item['isSelected'] && isEditableColumn(col, item)">
                            <teiasoft-confirmable-input [type]="getInputType(col)" [value]="getInputValue(item,col)"
                                (confirmChange)="onConfirmChange($event, item, col)"
                                (onValueChanged)="onValueChanged($event, item, col)"
                                [options]="uomOptionsMap[col+'_'+item.unitSystem]" style="width: 100%;">
                            </teiasoft-confirmable-input>
                        </ng-container>

                        <!-- If not in edit mode, display the regular content -->
                        <ng-container *ngIf="!item['isSelected'] || !isEditableColumn(col,item)">
                            <div>
                                <i *ngIf="hasValidationIssueExtraCost(item, col)"
                                    class="fas fa-triangle-exclamation ico-error" #tooltip="matTooltip"
                                    [matTooltip]="getValidationMessageExtraCost(item, col)" matTooltipPosition="below"
                                    matTooltipHideDelay="50">
                                </i>
                                <span *ngIf="!hasValidationIssueExtraCost(item, col)">{{ getInputValue(item,col)
                                    }}</span>
                            </div>
                        </ng-container>
                    </div>
                    <div *ngFor="let col of columns.costs; trackBy: trackByColumn"
                        [ngClass]="getConfirmableInputClass(col,item)" class="data-cost"
                        [style.width.px]="getColumnWidth(col)"
                        [matTooltip]="col === 'extraLeadTime' && hasValidationIssue(item, col) ? getValidationMessage(item, col) : ''"
                        [matTooltipDisabled]="col !== 'extraLeadTime' || !hasValidationIssue(item, col)"
                        matTooltipPosition="below" matTooltipHideDelay="50">
                        <ng-container *ngIf="col === 'deliveryDate'">
                            <div class="delivery-date-cell">
                                <span>{{ getInputValue(item,col) }}</span>
                                <span *ngIf="getItemRowDeliveryDatesCollection(item).length > 1"
                                    class="delivery-date-marker">*</span>
                                <span *ngIf="getItemRowDeliveryDatesCollection(item).length > 1"
                                    class="delivery-date-ico-cell">
                                    <i (click)="onItemDeliveryDatesClick(item); $event.stopPropagation()"
                                        class="extra-cost-icon fal fa-magnifying-glass"></i>
                                </span>
                            </div>
                        </ng-container>

                        <!-- If the row is in edit mode, use confirmable-input for editable fields -->
                        <ng-container *ngIf="col !== 'deliveryDate' && item['isSelected'] && isEditableColumn(col, item)">
                            <teiasoft-confirmable-input [type]="getInputType(col)" [value]="getInputValue(item,col)"
                                (confirmChange)="onConfirmChange($event, item, col)"
                                (onValueChanged)="onValueChanged($event, item, col)"
                                [options]="uomOptionsMap[col+'_'+item.unitSystem]" style="width: 100%;" [allowNegative]="doesColumnAllowNegative(col)">
                            </teiasoft-confirmable-input>
                        </ng-container>

                        <!-- If not in edit mode, display the regular content -->
                        <ng-container *ngIf="col !== 'deliveryDate' && (!item['isSelected'] || !isEditableColumn(col,item))">
                            <div>
                                <i *ngIf="col !== 'extraLeadTime' && hasValidationIssue(item, col)" class="fas fa-triangle-exclamation ico-error"
                                    #tooltip="matTooltip" [matTooltip]="getValidationMessage(item, col)"
                                    matTooltipPosition="below" matTooltipHideDelay="50">
                                </i>
                                <span *ngIf="!hasValidationIssue(item, col)">{{ getInputValue(item,col) }}</span>
                                <span *ngIf="col === 'extraLeadTime' && hasValidationIssue(item, col)">{{ getInputValue(item,col) }}</span>
                            </div>
                        </ng-container>
                    </div>
                </div>

            </div>

            <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
                <teiasoft-button (onClick)="onAddExtraCostClick()" [type]="'tb-primary'"
                    [text]="'enquiryBook.addExtraCost' | translate" [theme]="theme" [isMobile]="isMobile"
                    class="menu-button"></teiasoft-button>

                <!-- <teiasoft-button *ngIf="!gridFilterable" (onClick)="onAddExtraCostClick()" [type]="'tb-primary'"
                    style="margin-right: 1rem;" [text]="'enquiryBook.addExtraCost' | translate" [theme]="theme"
                    [isMobile]="isMobile"></teiasoft-button> -->

                <teiasoft-button (onClick)="onSaveClick()" class="mr-5" [type]="'tb-secondary'"
                    [text]="'commons.save' | translate" [theme]="theme" [isMobile]="isMobile"
                    [disabled]="hasValidationIssues"></teiasoft-button>
                <teiasoft-button (onClick)="onCloseModalClick()" [type]="'tb-cancel'"
                    [text]="'commons.cancel' | translate" [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
            </div>
        </div>
    </div>
</div>

<!-- MODAL -->
<app-modal-add-extra-costs *ngIf="showAddExtraCost" (onSave)="onAddExtraCostsSave($event)"
    (onCancel)="showAddExtraCost = false" [extraCostParameters]="availableExtraCost!">
</app-modal-add-extra-costs>

<app-modal-increase-column *ngIf="showIncreaseModal" [column]="focusedColumn"
    [columnLabel]="getColumnHeaderLabel(focusedColumn!)" [selectedItems]="getSelectedItems()"
    (onClose)="showIncreaseModal = false" (onApply)="applyIncrease($event)">
</app-modal-increase-column>


<teiasoft-grid-settings *ngIf="showSettingsDialog" [gridConfiguration]="gridConfiguration"
    (onClose)="onCloseSettings($event)" (onApply)="onApplySettings($event)" [disableSortingCriteria]="true"
    [columnDisabled]="['itemNo']" [hiddenColumns]="columns.costs.concat(columns.extraCosts)"
    [disableFreezeFeature]="false"></teiasoft-grid-settings>

<app-modal-item-delivery-dates *ngIf="showItemDeliveryDates" (onCancel)="showItemDeliveryDates = false"
    [enquiryNo]="enquiryNo" [item]="selectedDeliveryDatesItem!">
</app-modal-item-delivery-dates>
